import styled from 'styled-components';

import * as Modal from 'components/Modals/styles';
import 'components/Modals/loadingBar.css';

export const TransactionDetailsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & + & {
    margin-top: 16px;
  }
  span {
    font-weight: 400;
    color: ${props => props.theme.colors.textThirdly};
  }
  strong {
    font-weight: 500;
  }
`;

export const OptionsWrapper = styled.section`
  padding: 32px 32px;
  border-top: 1px solid ${props => props.theme.colors.bgHighlightBorder};
`;

export const OptionCaption = styled.p`
  margin: 0 0 12px;
  color: ${props => props.theme.colors.textThirdly};
`;

export const SlippageDesc = styled.p`
  margin: 16px 0 0;
  color: ${props => props.theme.colors.textSecondary};
`;

export const Options = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 0 16px;
`;

export const WalletIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.bgDarken};
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const OptionBtn = styled.button<{
  active?: boolean;
}>`
  padding: 12px 16px;
  background-color: ${props =>
    props.active ? props.theme.colors.bgHighlightBorder : 'transparent'};
  border: 1px solid ${props => props.theme.colors.bgHighlightBorder};
  border-radius: 22px;
  font-size: 14px;
  font-weight: 500;
  color: ${props =>
    props.active ? props.theme.colors.textPrimary : props.theme.colors.textSecondary};
  &:hover {
    background-color: ${props => props.theme.colors.bgHighlightBorder_lighten};
  }
  &:active {
    background-color: ${props => props.theme.colors.bgHighlightBorder_darken};
  }
`;

export const ExplorerButton = styled(Modal.SecondaryButton)`
  width: 100%;
  margin-top: 32px;
`;
